module.exports = __webpack_public_path__ + "icon-dgrid.1HBDmsJ2.svg";